import React, { useEffect } from "react";
import { useConfigurationState } from "./hooks/useConfigurationState";
import { DEFAULT_FOOD_TYPES } from "./types/configuration.types";
import { PageTitle } from "../PageTitle";
import { Button } from "src/business-types/grocery/components/Button";

const FoodTypesTab = () => {
  const { user, foodTypes, newType, addFoodType, setNewType, removeFoodType, saveFoodTypes, foodTypesChanged } = useConfigurationState();

  useEffect(() => {
    if (user?.businessType !== "Grocery") {
      document.title = "Food Types › Configuration › iMetanic";
    }
  }, []);

  return (
    <div className="w-full min-h-screen bg-gray-50">
      <PageTitle title=" - Configuration ›  Food Types" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {user?.businessType !== "Restaurant" ? (
          <div className="w-full border p-8 rounded-xl shadow bg-white text-center">
            <p className="text-gray-500">Food Types settings are only available for Restaurant business type.</p>
          </div>
        ) : (
          <div className="w-full border p-6 rounded-xl shadow bg-white">
            <h2 className="text-xl font-bold mb-6">Restaurant Food Types Configuration</h2>

            <p className="text-sm text-gray-600 mb-4">Configure food categories (Max 5 types)</p>

            {/* Food Type List */}
            <div className="flex flex-wrap gap-2 mb-4">
              {[...DEFAULT_FOOD_TYPES.filter((type) => foodTypes.includes(type)), ...foodTypes.filter((type) => !DEFAULT_FOOD_TYPES.includes(type))].map((type, index) => {
                const isDefaultType = DEFAULT_FOOD_TYPES.includes(type);

                return (
                  <div key={index} className="flex items-center gap-2 px-3 py-1 bg-green-100 text-green-800 rounded-full text-sm">
                    <span>{type}</span>

                    {!isDefaultType && (
                      <button onClick={() => removeFoodType(type)} className="text-red-600 hover:text-red-800 font-bold">
                        ×
                      </button>
                    )}
                  </div>
                );
              })}
            </div>

            {/* Add & Save */}
            {foodTypes.length < 5 && (
              <div className="flex gap-2 mb-4">
                <input
                  type="text"
                  value={newType}
                  onChange={(e) => setNewType(e.target.value)}
                  placeholder="Enter food type (e.g., Vegan)"
                  className="border px-3 py-2 rounded-md text-sm flex-1 max-w-xs"
                  onKeyDown={(e) => e.key === "Enter" && addFoodType()}
                />

                <button
                  onClick={addFoodType}
                  disabled={!newType.trim()}
                  className={`px-4 py-2 rounded-md text-sm text-white ${newType.trim() ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-300 cursor-not-allowed"}`}
                >
                  Add
                </button>
              </div>
            )}

            {foodTypes.length >= 5 && <p className="text-xs text-red-500 mb-4">Maximum 5 food types allowed</p>}

            <p className="text-xs text-gray-500 mb-4">Default types: {DEFAULT_FOOD_TYPES.join(", ")}</p>
            <div className="flex justify-center">
              <Button label="Save Food Types settings" onClick={() => saveFoodTypes({ foodTypes })} disabled={!foodTypesChanged} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FoodTypesTab;
